import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { PublishTermsContainer } from './PublishTerms.container';

app.component(
  'publishTermsContainer',
  react2angular(PublishTermsContainer, [], ['config', 'httpApi', 'logger', 'telemetry', 'microfrontend']),
);
